// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IconLink{cursor:pointer;display:inline-block;margin-left:2rem;position:relative}.IconLink>svg{left:-1.5em;margin-top:.125em;position:absolute}.IconLink--small>svg{left:-1.25em;margin-top:.3125em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
